/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import SqlImportModel from 'cio/models/sql-import';
import FormValidations from 'cio/utils/form-validations';
import AnalyticsService from 'cio/services/analytics';
import { inject as service } from '@ember/service';

interface SqlImportsCreateDetailsArgs {
  model: SqlImportModel;
  onSubmit: () => unknown;
  onCancel: () => unknown;
  readOnly: boolean;
}

const Validations = {
  name(value?: string) {
    if (!value || value?.trim() === '') {
      return "Name can't be blank";
    }

    return true;
  },
};

export default class SqlImportsCreateDetails extends Component<SqlImportsCreateDetailsArgs> {
  @service analytics!: AnalyticsService;
  readonly validations = FormValidations.create({
    context: this,
    validations: Validations,
    modelKey: 'args.model',
  });

  @action
  async onSubmit(ev: MouseEvent | KeyboardEvent) {
    ev.preventDefault();

    try {
      await this.validations.validateModel();
      this.analytics.track('sql_imports', 'sync_settings_started', { model: this.args.model });
      this.args.onSubmit();
    } catch {}
  }

  @action
  onNameChange(name: string) {
    this.args.model.set('name', name);
    this.validations.validateAttribute('name');
  }
}
